























import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { chain, orderBy } from 'lodash'
import { SystemCode } from '@/api'
import { systemCodeStore } from '@/utils/store-accessor'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { SortOrder } from '@/types'
import { SelectLostProceduresTableItem } from '@/components/organisms/SelectLostProceduresTable/index.type'

@Component({
  components: {
    DataTable
  }
})
export default class SelectLostProceduresTable extends ComponentVue {
  @PropSync('input', {
    type: String,
    required: true
  })
  selectedCode!: string

  @Prop({
    type: Number,
    default: 300
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '100',
        items: [
          {
            name: 'name',
            headerText: '内容',
            sortable: true,
            sortOrder: ''
          }
        ]
      }
    ]
  }

  get items(): SelectLostProceduresTableItem[] {
    return chain<SystemCode>(
      this.systemCodesOfLendOutCollectionLostExpulsionType
    )
      .filter((systemCode: SystemCode) => {
        return systemCode.code !== '5' && systemCode.code !== '6'
      })
      .transform(
        (result: SelectLostProceduresTableItem[], systemCode: SystemCode) => {
          result.push({
            code: systemCode.code,
            name: systemCode.name
          })
        }
      )
      .value()
  }

  get sortedItems(): SelectLostProceduresTableItem[] {
    if (this.sortOrder) {
      return orderBy<SelectLostProceduresTableItem>(
        this.items,
        this.sortName,
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  get systemCodesOfLendOutCollectionLostExpulsionType(): SystemCode[] {
    return systemCodeStore.getLendOutCollectionLostExpulsionType
  }

  deactivated(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  onClickRow(index: number): void {
    this.selectedCode = this.sortedItems[index].code
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''

    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
